"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPointOfInterests = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getPointOfInterests(_a) {
    var where = _a.where, orderBy = _a.orderBy, skip = _a.skip, take = _a.take;
    var variables = {
        where: where,
        orderBy: orderBy,
        skip: skip,
        take: take || 100,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query(\n        $where: PointOfInterestWhereInput\n        $take: Int\n        $skip: Int\n        $orderBy: [PointOfInterestOrderByInput!]\n      ) {\n        pointOfInterests(\n          where: $where\n          take: $take\n          skip: $skip\n          orderBy: $orderBy\n        ) {\n          id\n          createAt\n          pointNameAr\n          pointNameEn\n          type\n          property\n          lat\n          lng\n          isActive\n        }\n      }\n    "], ["\n      query(\n        $where: PointOfInterestWhereInput\n        $take: Int\n        $skip: Int\n        $orderBy: [PointOfInterestOrderByInput!]\n      ) {\n        pointOfInterests(\n          where: $where\n          take: $take\n          skip: $skip\n          orderBy: $orderBy\n        ) {\n          id\n          createAt\n          pointNameAr\n          pointNameEn\n          type\n          property\n          lat\n          lng\n          isActive\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getPointOfInterests = getPointOfInterests;
var templateObject_1;
